import { render, staticRenderFns } from "./QuickAddition.vue?vue&type=template&id=6c8524a2&scoped=true&"
import script from "./QuickAddition.vue?vue&type=script&lang=js&"
export * from "./QuickAddition.vue?vue&type=script&lang=js&"
import style0 from "./QuickAddition.vue?vue&type=style&index=0&id=6c8524a2&prod&scoped=true&lang=css&"
import style1 from "./QuickAddition.vue?vue&type=style&index=1&id=6c8524a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8524a2",
  null
  
)

export default component.exports